import { normalizeModelCategory } from '../../../capabilities/maas-model-storage/modelCategory';
import type { MaasModel } from '../../../capabilities/maas-model-storage/modelInstanceTypes';
import {
  normalizeModelSources,
  sanitizeModelSource,
  serializeModelSourceEntryForApi,
} from '../../../capabilities/maas-model-storage/modelSources';

export { getModelSourceType, sanitizeModelSource } from '../../../capabilities/maas-model-storage/modelSources';

export function serializeModelForApi(model: MaasModel): Record<string, unknown> | undefined {
  const mountPath = String(model.mountPath || '').trim();
  const sources = normalizeModelSources(model);
  if (!mountPath || !sources.length) return undefined;

  const serializedSources = sources
    .map((entry) => serializeModelSourceEntryForApi(entry))
    .filter((item): item is Record<string, unknown> => !!item);
  if (!serializedSources.length) return undefined;

  const modelTypes = normalizeModelCategory(model.types);
  return {
    mountPath,
    sources: serializedSources,
    ...(modelTypes.length ? { types: modelTypes } : {}),
  };
}
